import axios from 'axios';
import DashboardActions from 'react/member/actions/dashboard_actions';

export function callAPI(url, data, el) {
  return axios.post(url, data).then(({ data }) => {
    if (el?.props?.name) {
      DashboardActions.updateNotificationPreferenceEmit(el.props.name);
    }
    return data;
  });
}

export function getUrl(endpoint, accountId) {
  let url = `/member/dashboard/${endpoint}`;
  if (accountId) {
    url += `/${accountId}`;
  }
  return url;
}
